export default __webpack_public_path__ + "static/media/ai_face_recognitionActive.db03caba.svg";